import { useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useChatStore } from '@/stores/chatStore'
import { useChatOnlineStatus, useVisitorSession } from '@/hooks/useChat'
import { ChatButton } from './ChatButton'
import { ChatPanel } from './ChatPanel'

export function ChatWidget() {
  const { isOpen, visitorId, setOnline, setSession } = useChatStore()

  // Poll online status
  const { data: chatSettings } = useChatOnlineStatus()

  // Load existing session
  const { data: existingSession } = useVisitorSession(visitorId)

  // Sync online status to store
  useEffect(() => {
    if (chatSettings) {
      setOnline(chatSettings.online)
    }
  }, [chatSettings, setOnline])

  // Restore session from DB
  useEffect(() => {
    if (existingSession) {
      setSession(existingSession.id)
    }
  }, [existingSession, setSession])

  // Clear messages when panel closes to avoid stale data on reopen
  useEffect(() => {
    if (!isOpen) {
      // Don't clear session, just mark read
      useChatStore.getState().markAllRead()
    }
  }, [isOpen])

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-3">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            <ChatPanel />
          </motion.div>
        )}
      </AnimatePresence>

      <div className="relative">
        <ChatButton />
      </div>
    </div>
  )
}
